module.exports = __webpack_public_path__ + "img/mujer.07bb01c2.jpg";